import React from 'react'
import Logo1 from './logo1.png'
import Logo2 from './logo2.png'
import Logo3 from './logo3.png'
import Logo4 from './logo4.png'
import Logo5 from './logo5.png'
import Logo6 from './logo6.png'
import Logo7 from './logo7.png'
import Logo8 from './logo8.png'

function Clientes() {

  const carrusel = document.querySelector('.slide');
  let intervalo = null;
  let setp = 1;
  const start =()=>{
    intervalo = setInterval( function(){
      carrusel.scrollLeft = carrusel.scrollLeft + setp;
    },10);
  };

  start();


  return (
    <div className='slider'> 
      <div className='slide '>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div><div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo1} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo2} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo3} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo4} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo5} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo6} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo7} alt="" />
        </div>
        <div className="slide-track">
          <img src={Logo8}alt="" />
        </div>
        
        
      </div>



    </div>
  )
}

export default Clientes